/** "Cardiff" · "Cardiff & Newport" · "Cardiff, Newport & Bath" (max three named). */
export function formatAreas(areas: string[]): string {
  const named = areas.filter(Boolean).slice(0, 3);
  if (named.length <= 1) return named[0] ?? '';
  return `${named.slice(0, -1).join(', ')} & ${named[named.length - 1]}`;
}
